import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {Department, IShift} from '@signal/asp-data-commons';
import {LuxonDateAdapter} from '../../services/luxon-date-adapter';
import {AddItemComponent} from '../add-item/add-item.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {Store} from '@ngrx/store';
import {ScheduleRotationState} from '../../../store/schedule-rotation/schedule-rotation.reducer';
import {DeleteShift, UpdateShift} from '../../../store/schedule-rotation/schedule-rotation.actions';
import {Update} from '@ngrx/entity';
import { SubscriptionList } from '../../models/asp.types';
import { unsubscribeSubscriptions } from '../../services/util.service';

@Component({
  selector: 'app-schedule-shift',
  templateUrl: './schedule-shift.component.html',
  styleUrls: ['./schedule-shift.component.scss']
})
export class ScheduleShiftComponent implements OnInit, OnChanges, OnDestroy {
  @Input() shiftData: IShift;
  @Input() config: { department: Department, id: string };

  fromTime: any;
  toTime: any;
  private subs: SubscriptionList = {};

  constructor(public readonly dialog: MatDialog,
              private readonly luxonAdapter: LuxonDateAdapter,
              private readonly scheduleRotationState: Store<ScheduleRotationState>) {
  }

  ngOnInit() {
    this.assignFromToTimes();
  }

  deleteShift(id: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'scheduleRotation.deleteShiftConfirmation',
        popupBodyText: 'otherTexts.areYouSureDoYouWantToDeleteThisShift'
      },
      panelClass: 'asp-modal-container'
    });
    this.subs.dialog = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        this.scheduleRotationState.dispatch(new DeleteShift({...this.config, shiftId: this.shiftData.id}));
      }
    });
  }

  updateShift(shiftData: IShift) {
    const dialogRef = this.dialog.open(AddItemComponent, {
      width: '25rem',
      height: '484px',
      panelClass: 'asp-modal-container',
      data: {isEditMode: true, title: 'scheduleRotation.editShift', type: 'shift', formVal: shiftData,clicked:true},
      disableClose:true
    });
    this.subs.update = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        const updateShift: Update<IShift> = {
          id: this.shiftData.id,
          changes: {
            ...event.data
          }
        };
        this.scheduleRotationState.dispatch(new UpdateShift({...this.config, updateShift}));
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('shiftData')) {
      this.assignFromToTimes();
    }
  }

  private assignFromToTimes() {
    if(this.shiftData.fromTime != "Operational hours" && this.shiftData.toTime != "Operational hours"){
      this.fromTime = this.luxonAdapter.parse(this.shiftData.fromTime, undefined);
      this.toTime = this.luxonAdapter.parse(this.shiftData.toTime, undefined);
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
}
